import { render, staticRenderFns } from "./SelectItemsModal.vue?vue&type=template&id=03c1c7b7"
import script from "./SelectItemsModal.vue?vue&type=script&lang=js"
export * from "./SelectItemsModal.vue?vue&type=script&lang=js"
import style0 from "./SelectItemsModal.vue?vue&type=style&index=0&id=03c1c7b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports